import { useCallback, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { object, string } from 'yup';
import { useFormik } from 'formik';
import { FormModal } from './FormModal';
import { SelectInput } from '../inputs';
import {
  useDispatch,
  addResource,
  useSelector,
  warehousesSelectors,
  getBasicWarehouses,
} from '../../../state';
import { useRefresh } from '../../../hooks';

interface Props {
  open: boolean;
  handleClose: () => any;
  orderId: number;
}

interface State {
  warehouseId: string;
}

const initialState: State = {
  warehouseId: '',
};

export function TransferOrderForm({ open, handleClose, orderId }: Props) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const refresh = useRefresh();

  const warehouses = useSelector(warehousesSelectors.basicList);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    (async function () {
      await dispatch(getBasicWarehouses());
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = useCallback(
    async (values: State) => {
      setSubmitting(true);
      const { error } = await dispatch(
        addResource({
          baseUrl: `/orders/${orderId}/transfer-warehouse`,
          payload: {
            orderID: orderId,
            destinationWarehouseID: values.warehouseId,
          },
          message: 'Successfully transferred order',
        }),
      );
      setSubmitting(false);
      if (!error) {
        handleClose();
        refresh();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [orderId],
  );

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: false,
    onSubmit: handleSubmit,
    validationSchema: schema,
  });

  return (
    <FormModal
      open={open}
      handleClose={handleClose}
      title={
        <span className={classes.title}>{`Transfer order #${orderId}?`}</span>
      }
      callback={formik.handleSubmit}
      btnText='SAVE'
      typeSubmit
      paperProps={{ style: { width: 468 } }}
      submitting={submitting}
    >
      <SelectInput
        name='warehouseId'
        label='Select new warehouse'
        formikProps={formik}
        options={warehouses}
        autoFocus
      />
    </FormModal>
  );
}

const useStyles = makeStyles({ name: { TransferOrderForm } })((theme) => ({
  title: {
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: 600,
  },
}));

const schema = object().shape({
  warehouseId: string().required('Required'),
});
